import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import flatten from "lodash/flatten";
import { Element, Node } from "slate";

interface IFinancialHighlightsSummaryProps {
  lastFinancialHighlights: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["lastFinancialHighlights"]>;
}

export default function FinancialHighlightsSummary({ lastFinancialHighlights }: IFinancialHighlightsSummaryProps) {
  const topSentences = serializeToPlainTextSentences(lastFinancialHighlights.highlights).slice(0, 3);

  return (
    <div className="rounded bg-slate-100 p-3">
      <div className="line-clamp-2">
        <p className="m-0 text-sm font-medium text-slate-500">{topSentences.join(" ").slice(0, 160)}</p>
      </div>
    </div>
  );
}

function serializeToPlainTextSentences(nodes: Node[]): string[] {
  return flatten(
    nodes.map((node) => {
      // serialize list items with \n. So instead of it serializing as "A B C D" it will be:
      // A
      // B
      // C
      // D
      // TODO: https://github.com/ianstormtaylor/slate/issues/4915
      // @ts-ignore
      if (Element.isElement(node) && (node.type === "numbered-list" || node.type === "bulleted-list")) {
        return serializeToPlainTextSentences(node.children as Node[]);
      }

      return Node.string(node);
    }),
  );
}
